import { roundToDecimal } from './decimals'

const unitOrder = ['g', 'mg', 'mcg']

/**
 * @param {number} amount
 * @param {'g' | 'mg' | 'mcg'} unit
 * @param {number} weightInKg
 * @returns {string}
 */
export const getDosePerKg = (amount, unit, weightInKg) => {
  if (!amount || !unit || !weightInKg) {
    return ''
  }
  let res = amount / weightInKg
  let unitToUse = unit
  let precision = 1
  if (res < 0.1 && unit !== 'mcg') {
    res = res * 1000
    // next unit
    unitToUse = unitOrder[unitOrder.indexOf(unit) + 1]
  }

  if (res < 10) {
    precision = 2
  }

  return `${roundToDecimal(res, precision)}${unitToUse}/kg`
}
